
<template>
  <Card class="insights-card summary-card">
    <template #title>
      <div class="card-title summary-title">
        <i class="pi pi-comments card-icon" />
        Session Summary
      </div>
    </template>
    <template #content>
      <p class="summary-text">
        {{ summaryTargetLanguage }}
      </p>
      <p class="summary-text">
        {{ summaryLearnerLanguage }}
      </p>
    </template>
  </Card>
</template>

<script>
import Card from 'primevue/card'

export default {
  name: 'InsightsSummary',
  components: { Card },
  props: {
    summaryLearnerLanguage: {
      type: String,
      required: true
    },
    summaryTargetLanguage: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.insights-card {
  width: 100%;
  border-radius: 14px;
  border: 1.5px solid #6366f1;
  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.08);
  margin-bottom: 0;
  padding: 0;
}

.summary-card {
  border-color: #6366f1;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.08rem;
  font-weight: 700;
  color: #3730a3;
  padding: 10px 0 0 0;
}

.summary-title {
  color: #3730a3;
}

.card-icon {
  color: #6366f1;
  font-size: 1.2rem;
}

.summary-text {
  margin: 0;
  line-height: 1.7;
  color: #232946;
  font-size: 1.04rem;
  padding: 10px 18px 18px 18px;
  text-align: justify;
}
</style>
